
const state = {
  requestParameters: {},
  cellClicked: {},
  clientView: '',
  cellCondition: function () {}
}

const getters = {
}

const mutations = {
  commit_gridMetricSystemWideOneMetric_requestParams (state, params) {
    state.requestParameters = params
  },
  commit_gridMetricSystemWideOneMetric_cellClicked (state, cellClicked) {
    state.cellClicked = cellClicked
  },
  commit_gridMetricSystemWideOneMetric_clientView (state, clientView) {
    state.clientView = clientView
  },
  commit_gridMetricSystemWideOneMetric_cellCondition (state, condition) {
    state.cellCondition = condition
  }
}

const actions = {

}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/gridMetricSystemWideOneMetric.js